import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  BasePageMetaResolver,
  CmsService,
  PageLinkService,
  PageMetaService,
  RoutingPageMetaResolver,
  TranslationService,
} from '@spartacus/core';
import { ProductListComponentService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class KbPageTitleService extends BasePageMetaResolver {
  catTitle;
  crumbs$: Observable<any[]>;
  title: string;
  constructor(
    protected override cmsService: CmsService,
    protected override translation: TranslationService,
    protected override routingPageMetaResolver: RoutingPageMetaResolver,
    protected override router: Router,
    protected override pageLinkService: PageLinkService,
    protected pageMetaService: PageMetaService,
    private productListComponentService: ProductListComponentService
  ) {
    super(cmsService, translation, routingPageMetaResolver, router, pageLinkService);
  }
  protected pageTitle$: Observable<string | undefined> = this.page$.pipe(
    map((p) => {

      if (p?.title == 'B2Bendix') {
        return p.title;
      } else {
        switch (p?.pageId) {
          case 'homepage':
            return 'B2Bendix | ' +  p.title ;
          default:
            return p.title + ' | B2Bendix';
        }
      }
    })
  );

  override resolveTitle(): Observable<string | undefined> {


    return this.pageTitle$;
  }
  
}
